import { render, staticRenderFns } from "./counterTag.vue?vue&type=template&id=6dd709b6"
import script from "./counterTag.vue?vue&type=script&lang=js"
export * from "./counterTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports